module.exports = __webpack_public_path__ + "media/images/menu/titan-3103b1933dbbcd00cd0dbcf0340509d1.jpg";